import React, {useEffect, useState} from 'react';
import './sidebar.scss';
import SidebarItem from './SidebarItem';
// import items from '../../data/page.json';


const Sidebar = ({
                   // propMenus = undefined,
                   // propActiveMenu = undefined,
                   propSetSidebarMenuId = undefined,
                   propLocation = undefined,
                   propActiveMenuLv1 = undefined,
                   propActiveMenuLv2 = undefined,
                   propMenus = undefined,
                 }) => {

  useEffect(() => {
    // console.log(propActiveMenuLv1);
  }, [propActiveMenuLv1]);

  useEffect(() => {
    // console.log(propActiveMenuLv2);
    // console.log(propActiveMenuLv2[0]);
  }, [propActiveMenuLv2]);

  useEffect(() => {
    // console.log(propMenus);
  }, [propMenus]);


  /*const updateSidebarMenuId = (item) => {
    propSetSidebarMenuId(item.fnct_id);
  };


  useEffect(() => {
    if (Array.isArray(propMenus)) {
      if (propActiveMenuLv2) {
        console.log(propActiveMenuLv2);
        propMenus.map((item) => {
          if (item.kor_title === propActiveMenuLv2) {
            // eslint-disable-next-line array-callback-return
            item.childrens.map((it) => {
              if (it.path === propLocation) {
                return updateSidebarMenuId(it);
              }
            })
          }
        });
      }
    }
  }, [propMenus]);*/

  /*useEffect(() => {
    console.log(propLocation);
  }, [propLocation]);*/


  // const [authMenus, setAuthMenus] = useState([]);

  /*useEffect(() => {
    // console.log(propMenus);
    // console.log(items);
    // console.log(propActiveMenu);
    items.map((item) => {
      if (item.kor_title === propActiveMenu) {
        // console.log(item);
        // console.log(item.childrens);
        const menus = item.childrens;

        const result = menus.filter(it => {
          // console.log(it);
          // return !propMenus.some(other => other.menu_id === it.fnct_id)
          return propMenus.some(other => other.menu_id === it.fnct_id.toString());
        });

        // console.log(result);
        setAuthMenus(result);

      }
    });
  }, [propMenus]);





  let menus = [];

  // eslint-disable-next-line array-callback-return
  items.map((item) => {
    if (item.kor_title === propActiveMenu) {
      // console.log(item);
      return (
          <div className={'sidebar'}>
            {item.childrens.map((it) => {
              return menus.push(it);
            })}
          </div>
      );
    }
  });
*/

  const prefix = 'ui';

  // 대시보드 페이지에서 사이드바 제거 기능
  if (window.location.pathname === `/${prefix}/dash_platform`) return null;
  if (window.location.pathname === `/${prefix}/broker-server`) return null;
  if (window.location.pathname === `/${prefix}/dash_fire-status`) return null;
  if (window.location.pathname === `/${prefix}/dash_fire-status-events`) return null;
  if (window.location.pathname === `/${prefix}/sys_report-reg`) return null;
  if (window.location.pathname === `/${prefix}/dash`) return null;


  function isEmptyObj(obj) {
    return obj.constructor === Object && Object.keys(obj).length === 0;
  }

  return (
      /*<div className={'sidebar'}>
        {authMenus.map((item, index) => {
          return (
              <SidebarItem
                  key={index}
                  title={item.kor_title}
                  path={item.path}
                  icon={item.icon}
              />
          );
        })}
      </div>*/
      <div className={"sidebar"}>
        {isEmptyObj(propMenus) ?
            null :
            propMenus.map((item, index) => {
              return (
                  <SidebarItem
                      key={index}
                      title={item.menu_nm}
                      path={item.URI}
                      // icon={item.icon}
                  />
              );
            })}
      </div>
  );
};

export default Sidebar;
